import { computed, makeObservable, observable } from 'mobx';

export class WebhookEventViewModel {
    @observable isSelected: boolean;
    @observable url: string;

    constructor(isSelected: boolean, url: string) {
        this.isSelected = isSelected;
        this.url = url;
        makeObservable(this);
    }

    @computed
    get urlValid(): boolean {
        if (!this.isSelected) {
            return true;
        }
        let url: URL;
        try {
            url = new URL(this.url);
        } catch {
            return false;
        }
        if (url.protocol !== 'https:') {
            return false;
        }
        // Validate the hostname:
        let { hostname } = url;
        if (!hostname.endsWith('.')) {
            hostname += '.';
        }
        return /^(([0-9a-z]|[0-9a-z][-0-9a-z]{0,61}[0-9a-z])\.)+$/i.test(hostname);
    }
}
